/**
 * @generated SignedSource<<28358d61627fc8bef4fca27d9e41a53a>>
 * @relayHash 93869ef63ea6728086df26bf7fee35ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 909190e21c94c8720c09c105a3399859af3a1dd2592d10fe07fd62c602bf5aae

import type { ConcreteRequest, Query } from 'relay-runtime';
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type InlineCommentQueryParamsListenerInlineCommentQueryParamsQuery$variables = {
  commentId: string;
};
export type InlineCommentQueryParamsListenerInlineCommentQueryParamsQuery$data = {
  readonly comments: {
    readonly nodes: ReadonlyArray<{
      readonly ancestors: ReadonlyArray<{
        readonly author: {
          readonly accountId?: string | null | undefined;
          readonly displayName: string | null | undefined;
          readonly permissionType: SitePermissionType | null | undefined;
          readonly profilePicture: {
            readonly path: string;
          } | null | undefined;
        };
        readonly id: string;
        readonly location: {
          readonly inlineMarkerRef?: string | null | undefined;
          readonly inlineResolveProperties?: {
            readonly resolved: boolean;
          } | null | undefined;
          readonly type: string;
        };
      } | null | undefined>;
      readonly author: {
        readonly accountId?: string | null | undefined;
        readonly displayName: string | null | undefined;
        readonly permissionType: SitePermissionType | null | undefined;
        readonly profilePicture: {
          readonly path: string;
        } | null | undefined;
      };
      readonly id: string;
      readonly location: {
        readonly inlineMarkerRef?: string | null | undefined;
        readonly inlineResolveProperties?: {
          readonly resolved: boolean;
        } | null | undefined;
        readonly type: string;
      };
      readonly parentId: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type InlineCommentQueryParamsListenerInlineCommentQueryParamsQuery = {
  response: InlineCommentQueryParamsListenerInlineCommentQueryParamsQuery$data;
  variables: InlineCommentQueryParamsListenerInlineCommentQueryParamsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "commentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "commentId",
    "variableName": "commentId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v4 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "permissionType"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v7 = {
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/)
  ]
},
v8 = {
  "kind": "ScalarField",
  "name": "type"
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "inlineMarkerRef"
    },
    {
      "concreteType": "InlineCommentResolveProperties",
      "kind": "LinkedField",
      "name": "inlineResolveProperties",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "resolved"
        }
      ]
    }
  ],
  "type": "InlineComment"
},
v10 = {
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/)
  ]
},
v11 = {
  "kind": "ScalarField",
  "name": "parentId"
},
v12 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v13 = {
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/)
  ]
},
v14 = {
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "InlineCommentQueryParamsListenerInlineCommentQueryParamsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
          {
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v7/*: any*/),
              (v10/*: any*/),
              {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v7/*: any*/),
                  (v10/*: any*/)
                ]
              },
              (v11/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InlineCommentQueryParamsListenerInlineCommentQueryParamsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
          {
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/)
                ]
              },
              (v11/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "93869ef63ea6728086df26bf7fee35ac",
    "id": "909190e21c94c8720c09c105a3399859af3a1dd2592d10fe07fd62c602bf5aae",
    "metadata": {},
    "name": "InlineCommentQueryParamsListenerInlineCommentQueryParamsQuery",
    "operationKind": "query",
    "text": "query InlineCommentQueryParamsListenerInlineCommentQueryParamsQuery($commentId:ID!){comments(commentId:$commentId){nodes{id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved}}},ancestors{id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved}}}},parentId}}}"
  }
};
})();

(node as any).hash = "101bf587c7e4148c07a0c0957b8ef4ca";

export default node;
